export default "__VITE_ASSET__CBOZ3ojY__"